module.exports = __webpack_public_path__ + "img/Aroma.e787af06.png";